<template>
  <body>
    <div id="content">
      <iframe
        src="https://analytics.blubirch.com/home/#/opendocument?data=eyJ1c2VyIjoiMzI3NzUiLCJzcGFjZWtleSI6IjExMTEiLCJkb2NJZCI6IjM2NzAwNTciLCJhbGciOiJIUzI1NiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAAADWQy3ZDQABA_8W6cjCZQXdeYTQaohKycWSMRMSjBiU9_femi97d3d1zv7nbUHKvHJBkGXIvHBvPT6OLez3bpNyVLo4eWHwvMcNN1xEDI1zlWXjQyiJYOWuGtX90yWNBb3rabKXC4aFX9VF2jWFbnGKK-yEwLoKe5abhN-CzBx34GNdW2jXXS7Mznajn081ohwlNa2mY2drZa2KtjuAU18ni6Tv_xmsCrpLqK7fhxsbVFFLlGoVHUyce808jVJcodOeoaSdlP_Ln-6aN98bn1rrPxRDSTG3JX-XKgWR6WyByFMWW3YlRvousfGmX6UHvsVgl1O-MUsLBLXjuKBl77kCkkJEKEFoTArKsEJFMkKBAkVAVghxyP7_MaesGRwEAAA.slFcAE_g2XpB_kLvOXL1BzgcEdbfzNfw_JaUZ0oKYwk"
      ></iframe>
    </div>
  </body>
</template>

<script>
export default {
  name: "operationsDashboard",
};
</script>

<style media="screen" scoped>
iframe {
  border: none;
  height: 100vh;
  width: 95vw;
  margin-left: -8px;
}
</style>
